/**
 * Consent API service
 *
 * google-sign-in/US-004 (T4): Implements API-001 (POST /auth/consent).
 * Follows the exact api.post<T>(path, body) pattern authApi.ts already
 * establishes for every /auth/* call — the Authorization header is
 * auto-attached by the shared request interceptor (frontend/src/lib/api.ts).
 * No try/catch here: errors already transformed by the response interceptor
 * (frontend/src/lib/api.ts) propagate to the caller unchanged (mirrors
 * authApi.ts's own comment: "Error already transformed by axios interceptor").
 */

import api from '@/lib/api';

/** Response shape from POST /auth/consent (API-001 success schema). */
export interface ConsentResponse {
  consent: {
    termsVersion: string;
    termsEffectiveDate: string;
    termsAcceptedAt: string;
    privacyVersion: string;
    privacyEffectiveDate: string;
    privacyAcceptedAt: string;
  };
  consentPending: false;
}

/**
 * Record PDPA/T&C consent for the authenticated parent.
 *
 * google-sign-in/US-004 (T4) / BR-004.2: body is EXACTLY { acceptTnc: true }
 * — no timestamps or versions are ever sent from the client; the server is
 * the sole authority for acceptedAt and the terms/privacy versions.
 *
 * @throws {AuthError} on 400/401/403/404/500 (see API-001 error schema)
 */
export async function recordConsent(): Promise<ConsentResponse> {
  const response = await api.post<ConsentResponse>('/auth/consent', { acceptTnc: true });
  return response.data;
}
